import React, { Component } from 'react';
import { Modal, Button, Table } from 'antd';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import TableC from '../../basicElement/TableC';
import format from '../../shared/format';

class TotalPiceRequestRecord extends Component {
    state = {
        data: [],
        record: {},
        visible: false,
        loading: false,
        talAuth: false,
    }

    show = (record = {}, talAuth = false) => {
        this.setState({
            record,
            visible: true,
            talAuth,
        }, () => {
            this.loadData();
        });
    }

    hide = () => {
        this.setState({
            visible: false,
        });
    }

    loadData = () => {
        const { record: { evaluateRecordId }, talAuth } = this.state;
        if (!evaluateRecordId) {
            return
        }
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.evaluate.queryClinicalQuotationTotalPriceApplication,
            data: { evaluateRecordId },
            dataType: 'json',
            doneResult: res => {
                this.setState({
                    data: res.data,
                    loading: false,
                })
            }
        };
        $.sendRequest(options);
    }

    getColumns = () => {
        const columns = [
            {
                title: '总价审批通过/总价确认时间',
                dataIndex: 'confirmTime',
                key: 'confirmTime',
                width: 100,
            }, {
                title: '建议报价方式',
                dataIndex: 'basePriceStatusName',
                key: 'basePriceStatusName',
                width: 100,
            }, {
                title: '启动中心数',
                dataIndex: 'startSiteNum',
                key: 'startSiteNum',
                width: 80,
            }, {
                title: '随机病例数',
                dataIndex: 'randomCaseNum',
                key: 'randomCaseNum',
                width: 80,
            }, {
                title: '研究周期(月)',
                dataIndex: 'researchCycle',
                key: 'researchCycle',
                width: 60,
            }, {
                title: '入组期(月)',
                dataIndex: 'joinGroupPeriod',
                key: 'joinGroupPeriod',
                width: 60,
            }, {
                title: '治疗期(月)',
                dataIndex: 'treatmentPeriod',
                key: 'treatmentPeriod',
                width: 60,
            }, {
                title: '随访期(月)',
                dataIndex: 'followUpPeriod',
                key: 'followUpPeriod',
                width: 60,
            }, {
                title: '生存随访期(月)',
                dataIndex: 'survivalFollowUpPeriod',
                key: 'survivalFollowUpPeriod',
                width: 60,
            }
        ];

        columns.push({
            title: 'GP%',
            dataIndex: 'gpCalcuationValue',
            key: 'gpCalcuationValue',
            width: 80,
            render: (text, record) => {
                const { curRole }= sessionStorage;
                const {talAuth} = this.state;
                const showGpValue = (curRole == 'BD' || curRole == 'BA' || curRole == 'BDO' || curRole == 'BAL'|| curRole == 'BDM') ? !talAuth : true;
                return showGpValue ? (text? `${text}%` : (text === 0 ? '0' : '')) : ''
            }
        });
        
        columns.push({
            title: '单例价格金额(含税)/人民币',
            dataIndex: 'unitPrice',
            key: 'unitPrice',
            width: 100,
            render: (text, record) => {
                const { serveFeeType, unitPrice, nonBindUnitPrice } = record
                let show = 0;
                if (serveFeeType !== "NON_BIND,BIND") {
                    show = serveFeeType == 'NON_BIND' ? format('money', nonBindUnitPrice) : format('money', unitPrice);
                }
                return show
            }
        }, {
            title: '盲态服务单例价格金额(含税)/人民币',
            dataIndex: 'unitPrice',
            key: 'bindUnitPrice',
            width: 100,
            render: (text, record) => {
                const { serveFeeType } = record
                let show = 0;
                if (serveFeeType == "NON_BIND,BIND") {
                    show = (text || text == 0)  ? format('money', text) : '';
                }
                return show
            }
        }, {
            title: '非盲服务单例价格金额(含税)/人民币',
            dataIndex: 'nonBindUnitPrice',
            key: 'nonBindUnitPrice',
            width: 100,
            render: (text, record) => {
                const { serveFeeType } = record
                let show = 0;
                if (serveFeeType == "NON_BIND,BIND") {
                    show = (text || text == 0)  ? format('money', text) : '';
                }
                return show
            }
        }, {
            title: '总价金额(含税)/人民币',
            dataIndex: 'totalPrice',
            key: 'totalPrice',
            width: 80,
            render: (text, record) => {
                const { serveFeeType, totalPrice, nonBindTotalPrice } = record
                let show = 0;
                if (serveFeeType !== "NON_BIND,BIND") {
                    show = serveFeeType == 'NON_BIND' ? format('money', nonBindTotalPrice) : format('money', totalPrice);
                }
                return show
            }
        }, {
            title: '盲态服务总价金额(含税)/人民币',
            dataIndex: 'totalPrice',
            key: 'bindTotalPrice',
            width: 80,
            render: (text, record) => {
                const { serveFeeType } = record
                let show = 0;
                if (serveFeeType == "NON_BIND,BIND") {
                    show = (text || text == 0)  ? format('money', text) : '';
                }
                return show
            }
        }, {
            title: '非盲服务总价金额(含税)/人民币',
            dataIndex: 'nonBindTotalPrice',
            key: 'nonBindTotalPrice',
            width: 80,
            render: (text, record) => {
                const { serveFeeType } = record
                let show = 0;
                if (serveFeeType == "NON_BIND,BIND") {
                    show = (text || text == 0)  ? format('money', text) : '';
                }
                return show
            }
        });

        return columns
    }

    render() {
        const { visible, loading, data, record } = this.state;
        const { evaluateCode, evaluateSerialNumber } = record;
        return (
            <Modal
                title="总价申请记录"
                visible={visible}
                onCancel={this.hide}
                className="preview-modal"
                maskClosable={false}
                width="1000px"
                bodyStyle={{
                    minHeight: 450
                }}
                footer={<Button onClick={this.hide}>关闭</Button>}
            >
                <div className="cont-cont contract-record" style={{margin: 20}}>
                    <div style={{ marginBottom: 16 }}>
                        临床评估单号：{evaluateCode}&nbsp;&nbsp;&nbsp;&nbsp;方案编号：{evaluateSerialNumber}
                    </div>
                    <div>
                        <TableC
                            data={data}
                            loading={loading}
                            columns={this.getColumns()}
                            pagination={false}
                            scrollY={300}
                        />
                        <div style={{ position: 'relative', top: -1, borderTop: '1px solid #e4e4e4' }} />
                    </div>
                </div>
            </Modal>
        );
    }
}

export default TotalPiceRequestRecord;


// WEBPACK FOOTER //
// ./src/components/businessOffer/businessOfferRecord/TotalPiceRequestRecord.js